import {
  CommonGraphicWidgetConfigSchema,
  DefaultAssignableExpressionSchema,
} from '@framework/engine';
import { yup } from '@framework/validation';
import { ISiapDataWidget, WidgetSiapDataType } from './ISiapDataWidget';

export const SiapDataConfigSchema: yup.ObjectSchema<ISiapDataWidget> =
  CommonGraphicWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetSiapDataType).required(),
    aooField: DefaultAssignableExpressionSchema,
  })
    .required()
    .noUnknown();
